<mat-card class="height-100">
  <mat-card-header class="border-bottom">
    <mat-card-title>
      Adicionar condição de pagamento
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Dados" style="flex: 1;">
        <ng-template mat-tab-label>
          Dados
          <i
            *ngIf="formDadosValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <div class="flex-column mt-2 col-md-12">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>
              Descrição
            </mat-label>
            <input
              matInput
              type="text"
              [formControl]="form_dados.get('descricao')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form_dados.get('descricao').touched &&
              form_dados.get('descricao').hasError('required')
            "
          >
            {{ messages['descricao'].required }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form_dados.get('descricao').touched &&
              form_dados.get('descricao').hasError('maxlength')
            "
          >
            {{ messages['descricao'].maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form_dados.get('descricao').touched &&
              form_dados.get('descricao').hasError('isEmptyValue')
            "
          >
            {{ messages['descricao'].isEmptyValue }}
          </small>
        </div>
        <div class="row m-0 pt-2">
          <fast-autocomplete
            #input
            [autoFirst]="false"
            id="field-tabela-preco"
            placeholder="Tabela de preço"
            required
            [domain_id]="tokenService.getDomain().id"
            class="mt-2 col-md-12"
            (clearSelection)="form_dados.get('tabela_preco').reset()"
            displayField="nome"
            [control]="form_dados.get('tabela_preco')"
            [entityService]="tabPreco"
            [initDataWithEmpty]="true"
            [messages]="{
              required: 'Tabela de preço é requerida.',
              typeIs: 'Valor inválido',
              isEmptyValue: 'Valor inválido: remova os espaços em branco!'
            }"
            [insertType]="'tabela_preco'"
            [value_order]="'nome'"
            [pageValue]="'0'"
            [pageSizeValue]="'10'"
          ></fast-autocomplete>
        </div>
        <mat-checkbox
          *ngIf="usaCatalogo"
          color="primary"
          class="mt-2 col-md-4 mt-1"
          [formControl]="form_dados.get('catalogo_usa')"
        >
          Usado também no catalogo?
        </mat-checkbox>
      </mat-tab>
      <mat-tab label="Parcelas" style="flex: 1;">
        <ng-template mat-tab-label>
          Parcelas
          <i
            *ngIf="formParcelasValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Adicione pelo menos uma parcela"
          ></i>
        </ng-template>
        <div class="row m-0 pt-2">
          <fast-autocomplete
            #input
            id="field-forma-pagto"
            [autoFirst]="false"
            placeholder="Forma de pagamento"
            class="mt-2 col-md-6"
            displayField="nome"
            [value_order]="'nome'"
            [domain_id]="tokenService.getDomain().id"
            [pageValue]="'0'"
            (clearSelection)="form.get('forma_pagamento').reset()"
            [pageSizeValue]="'20'"
            [control]="form.get('forma_pagamento')"
            [entityService]="formaPagamentoService"
            [openDialogAddEntity]="addFormPagamento"
            [initDataWithEmpty]="true"
            [messages]="{
              required: 'Forma de pagamento é obrigatória.',
              typeIs: 'Valor inválido',
              isEmptyValue: 'Valor inválido: remova os espaços em branco!'
            }"
            [insertType]="'forma_pgmt'"
          ></fast-autocomplete>
          <div class="flex-column mt-2 col-md-4">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>
                Dias de prazo
              </mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('dias_prazo')"
                (keypress)="enterParcela($event)"
                name="diasdeprazo"
                (keydown)="validateOnlyNumbers($event)"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('dias_prazo').touched &&
                form.get('dias_prazo').hasError('existSpecialChar')
              "
            >
              Valor inválido, não aceita pontuação!
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('dias_prazo').touched &&
                form.get('dias_prazo').hasError('required')
              "
            >
              Dias de prazo é requerido.
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('dias_prazo').touched &&
                form.get('dias_prazo').hasError('mazlength')
              "
            >
              Valor de dias inválido
            </small>
          </div>
        </div>
        <div class="mx-3 d-flex">
          <button
            pButton
            pRipple
            iconPos="left"
            label="Adicionar"
            icon="pi pi-plus-circle"
            class="p-button-primary p-button-text"
            id="btn-add-list-entity"
            [disabled]="!form.valid"
            (click)="addParcela()"
          ></button>
          <button
            pButton
            pRipple
            iconPos="left"
            label="Remover"
            icon="pi pi-minus-circle"
            class="p-button-danger p-button-text"
            id="btn-add-list-entity"
            [disabled]="!selection.hasValue()"
            (click)="removeParcela()"
          ></button>
        </div>
        <div class="mt-2 col-md-12">
          <table mat-table class="w-100" [dataSource]="dataSource">
            <ng-container matColumnDef="numero">
              <th mat-header-cell *matHeaderCellDef>No.</th>
              <td mat-cell *matCellDef="let element">{{ element.numero }}</td>
            </ng-container>
            <ng-container matColumnDef="forma_pagamento">
              <th mat-header-cell *matHeaderCellDef>Forma de pagamento</th>
              <td mat-cell *matCellDef="let element">
                {{ element.forma_pagamento.nome | uppercase }}
              </td>
            </ng-container>
            <ng-container matColumnDef="dias_prazo">
              <th mat-header-cell *matHeaderCellDef>Dias de prazo</th>
              <td mat-cell *matCellDef="let element">
                {{ element.dias_prazo }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="selection.toggle(row)"
              [ngClass]="{
                hovered: row.hovered,
                highlighted: selection.isSelected(row)
              }"
              (mouseover)="row.hovered = true"
              (mouseout)="row.hovered = false"
            ></tr>
          </table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
  <mat-card-actions>
    <div
      class="mt-2 col-md-12 pb-2"
      style="display: flex; justify-content: flex-end;"
    >
      <button mat-stroked-button color="warn" [matDialogClose]="undefined">
        Cancelar
      </button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!isValid"
        (click)="submit()"
      >
        Cadastrar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
